/* ==========================================================================
   Gooey Button  —  behaviour
   Turns every  <a class="gooey-btn" href="...">Label</a>  into the pill+circle
   button. Width is measured from the label; the silhouette (your Vector.svg)
   stretches only in the middle so caps, neck and circle keep their shape at
   any width. Colours come from CSS variables (see the CSS file).

   Usage:
     <link rel="stylesheet" href="gooey-button.css">
     <script src="gooey-button.js"></script>
     <a class="gooey-btn" href="/shop">Shop Now</a>

   Auto-runs on DOMContentLoaded. Re-run after adding buttons dynamically:
     GooeyButton.upgradeAll();
     new GooeyButton(element);
     GooeyButton.refresh();

   Modifier classes:
     .left   put the circle/indicator on the LEFT (default is right)
     .dot    show a filled dot inside the circle instead of the arrow

   Per-button options via data-attributes:
     data-gb-arrow="false"   hide the corner arrow (empty circle)
   ========================================================================== */
(function (global) {
  "use strict";

  var SVGNS = "http://www.w3.org/2000/svg";

  var ORIG_PATH =
    "M0.621857 15.1522V16.0804C0.621857 24.1114 7.24542 30.6218 15.416 30.6218H93.3236C99.3715 30.6218 104.573 27.0554 106.865 21.9453C107.754 19.9637 109.769 18.7038 111.972 18.7038C114.176 18.7038 116.191 19.9637 117.08 21.9453C119.372 27.0554 124.573 30.6218 130.621 30.6218H131.828C139.998 30.6218 146.622 24.1114 146.622 16.0804V15.1632C146.622 7.13224 139.998 0.621826 131.828 0.621826H130.621C124.756 0.621826 119.687 3.98136 117.294 8.84374C116.367 10.7276 114.404 11.9025 112.275 11.9025H111.67C109.541 11.9025 107.577 10.7275 106.65 8.84367C104.258 3.98133 99.1883 0.621826 93.3236 0.621826H15.416C7.24455 0.621826 0.621857 7.13112 0.621857 15.1522Z";

  var VB_H   = 32,
      MAXX    = 146.622,
      THRESH  = 50,
      XL      = 15.416,
      XR      = 93.3236,
      CXO     = 131.622,
      RO      = 15,
      PADF    = 0.35,
      DOTF    = 0.2;        // dot radius as a fraction of height

  var TOKEN_RE = /[MLHVCSQTAZ]|-?\d*\.?\d+(?:e-?\d+)?/gi;
  var SPEC = { M:["x","y"], L:["x","y"], H:["x"], V:["y"],
               C:["x","y","x","y","x","y"], Z:[] };

  /* flip = true mirrors the whole silhouette horizontally (circle on the left) */
  function remapPath(W, H, flip) {
    var sy = H / VB_H;
    var fx = function (x) {
      var v = (x < THRESH ? x * sy : W - (MAXX - x) * sy);
      return flip ? W - v : v;
    };
    var fy = function (y) { return y * sy; };
    var toks = ORIG_PATH.match(TOKEN_RE);
    var out = [], i = 0, cmd;
    while (i < toks.length) {
      var t = toks[i];
      if (SPEC[t.toUpperCase()] !== undefined) {
        cmd = t.toUpperCase(); out.push(t); i++;
        if (cmd === "Z") continue;
        var types = SPEC[cmd];
        while (i < toks.length && !/^[MLHVCSQTAZ]$/i.test(toks[i])) {
          for (var k = 0; k < types.length; k++) {
            var v = parseFloat(toks[i]); i++;
            out.push((types[k] === "x" ? fx(v) : fy(v)).toFixed(3));
          }
        }
      } else { i++; }
    }
    return out.join(" ");
  }

  function el(name, attrs) {
    var e = document.createElementNS(SVGNS, name);
    if (attrs) for (var k in attrs) e.setAttribute(k, attrs[k]);
    return e;
  }

  /* Vertical offset (px) from the alphabetic baseline to the optical centre of
     the rendered text, measured with canvas metrics. Positive = baseline sits
     below the ink centre. Compensates for fonts with asymmetric ascent/descent. */
  var _measureCtx = null;
  function inkBaselineOffset(refEl, text) {
    try {
      if (!_measureCtx) _measureCtx = document.createElement("canvas").getContext("2d");
      var cs = getComputedStyle(refEl);
      _measureCtx.font = cs.fontWeight + " " + cs.fontSize + " " + cs.fontFamily;
      var m = _measureCtx.measureText(text);
      if (typeof m.actualBoundingBoxAscent !== "number") return null;
      return (m.actualBoundingBoxAscent - m.actualBoundingBoxDescent) / 2;
    } catch (e) { return null; }
  }

  var uidCounter = 0;

  function GooeyButton(node) {
    if (!node || node.__gooey) return node && node.__gooey;
    this.node = node;
    node.__gooey = this;
    this.uid = "gb" + (++uidCounter);
    this.label = (node.getAttribute("data-gb-label") || node.textContent || "").trim();

    this.flip    = node.classList.contains("left");
    this.showDot = node.classList.contains("dot");
    this.showArrow = !this.showDot && node.getAttribute("data-gb-arrow") !== "false";

    if (!node.getAttribute("aria-label")) node.setAttribute("aria-label", this.label);
    this.build();
    this.measureAndLayout();
    node.classList.add("gb-ready");
    GooeyButton._all.push(this);
  }

  GooeyButton.prototype.build = function () {
    var node = this.node;
    this.loadingOverlay = node.querySelector(".loading-overlay__spinner");
    if (this.loadingOverlay) {
      node.removeChild(this.loadingOverlay);
    }
    node.textContent = "";

    var svg = el("svg", { xmlns: SVGNS, "aria-hidden": "true" });
    this.svg = svg;

    this.fillPath = el("path", { class: "gb-fill" });
    svg.appendChild(this.fillPath);

    var common = { "text-anchor": "middle", "dominant-baseline": "central" };
    this.txtBase = el("text", common);
    this.txtBase.setAttribute("class", "gb-txt");
    this.txtBase.textContent = this.label;
    svg.appendChild(this.txtBase);

    if (this.showDot) {
      this.dot = el("circle", { class: "gb-dot" });
      svg.appendChild(this.dot);
    } else if (this.showArrow) {
      this.arrowWrap = el("g");
      this.arrowInner = makeArrow("gb-arrow");
      this.arrowWrap.appendChild(this.arrowInner.group);
      svg.appendChild(this.arrowWrap);
    }

    this.strokePath = el("path", { class: "gb-stroke" });
    svg.appendChild(this.strokePath);

    node.appendChild(svg);

    if (this.loadingOverlay) {
      node.appendChild(this.loadingOverlay);
    }
  };

  function makeArrow(cls) {
    var g = el("g", { class: cls });
    var line = el("line");
    var head = el("polyline");
    g.appendChild(line);
    g.appendChild(head);
    return { group: g, line: line, head: head };
  }

  GooeyButton.prototype.cssNum = function (name, fallback) {
    var v = getComputedStyle(this.node).getPropertyValue(name);
    var n = parseFloat(v);
    return isNaN(n) ? fallback : n;
  };

  GooeyButton.prototype.measureAndLayout = function () {
    var H = this.cssNum("--gb-height", 30);
    var sy = H / VB_H;
    var flip = this.flip;

    var tw = 0;
    try { tw = this.txtBase.getComputedTextLength(); } catch (e) {}
    if (!tw) tw = this.label.length * H * 0.55;

    var pad = H * PADF;
    var fixed = (XL + (MAXX - XR)) * sy;
    var W = tw + 2 * pad + fixed;
    var minW = (XL + (MAXX - XR) + 8) * sy;
    if (W < minW) W = minW;

    // indicator centre + text centre (mirrored when .left)
    var cxR = W - (MAXX - CXO) * sy;          // circle centre, default (right)
    var cx  = flip ? (W - cxR) : cxR;
    var cy  = H / 2;
    var txcR = (XL * sy + (W - (MAXX - XR) * sy)) / 2;
    var txc  = flip ? (W - txcR) : txcR;

    var path = remapPath(W, H, flip);

    this.svg.setAttribute("width", W.toFixed(1));
    this.svg.setAttribute("height", H.toFixed(1));
    this.svg.setAttribute("viewBox", "0 0 " + W.toFixed(1) + " " + H.toFixed(1));
    this.node.style.width = W.toFixed(1) + "px";

    this.fillPath.setAttribute("d", path);
    this.strokePath.setAttribute("d", path);

    this.txtBase.setAttribute("x", txc.toFixed(1));
    /* centre on the actual ink box of the label rather than font metrics,
       so custom fonts with lopsided ascent/descent still sit centred */
    var displayText = this.txtBase.textContent || this.label;
    var ink = inkBaselineOffset(this.txtBase, displayText.toUpperCase());
    if (ink !== null) {
      this.txtBase.setAttribute("dominant-baseline", "alphabetic");
      this.txtBase.setAttribute("y", (cy + ink).toFixed(2));
    } else {
      this.txtBase.setAttribute("dominant-baseline", "central");
      this.txtBase.setAttribute("y", cy);
    }

    if (this.showDot) {
      var r = H * DOTF * this.cssNum("--gb-dot-scale", 1);
      this.dot.setAttribute("cx", cx.toFixed(2));
      this.dot.setAttribute("cy", cy.toFixed(2));
      this.dot.setAttribute("r",  r.toFixed(2));
    } else if (this.showArrow) {
      var a = H * 0.46, sw = (H * 0.08).toFixed(2);
      var f0 = 0.28, f1 = 0.72;
      var s = flip ? -1 : 1;
      this.arrowWrap.setAttribute("transform",
        "translate(" + cx.toFixed(2) + "," + cy.toFixed(2) + ") " +
        "scale(" + s + ",1) translate(" + (-a / 2).toFixed(2) + "," + (-a / 2).toFixed(2) + ")");
      this.arrowInner.group.setAttribute("stroke-width", sw);
      setAttrs(this.arrowInner.line, { x1: (a*f0).toFixed(2), y1: (a*f1).toFixed(2),
                          x2: (a*f1).toFixed(2), y2: (a*f0).toFixed(2) });
      this.arrowInner.head.setAttribute("points",
        (a*f0).toFixed(2)+","+(a*f0).toFixed(2)+" "+
        (a*f1).toFixed(2)+","+(a*f0).toFixed(2)+" "+
        (a*f1).toFixed(2)+","+(a*f1).toFixed(2));
    }
  };

  function setAttrs(node, attrs) { for (var k in attrs) node.setAttribute(k, attrs[k]); }

  GooeyButton._all = [];
  GooeyButton.upgradeAll = function (selector) {
    var nodes = document.querySelectorAll(selector || ".gooey-btn");
    for (var i = 0; i < nodes.length; i++) {
      if (!nodes[i].__gooey) new GooeyButton(nodes[i]);
    }
  };
  GooeyButton.refresh = function () {
    GooeyButton._all.forEach(function (b) { b.measureAndLayout(); });
  };

  function boot() {
    GooeyButton.upgradeAll();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(GooeyButton.refresh);
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else { boot(); }

  var rt;
  window.addEventListener("resize", function () {
    clearTimeout(rt); rt = setTimeout(GooeyButton.refresh, 150);
  });

  global.GooeyButton = GooeyButton;
})(window);
